<template>
  <b-modal
      :visible="visible"
      :title="song ? `Привязать: ${song.artist_name} — ${song.title}` : 'Привязать'"
      size="lg"
      hide-footer
      @change="$emit('change', $event)"
      @show="reset"
  >
    <b-overlay :show="isSaving" rounded="sm">
      <b-form-group :label="isAlbum ? 'Артист' : 'Трек'">
        <b-input-group>
          <b-form-input v-model="query" placeholder="Поиск" @keyup.enter="search"/>
          <b-input-group-append>
            <b-button variant="primary" :disabled="isSearching" @click="search">Найти</b-button>
          </b-input-group-append>
        </b-input-group>
      </b-form-group>

      <b-list-group v-if="results.length">
        <b-list-group-item
            v-for="item in results"
            :key="item.id"
            button
            class="d-flex justify-content-between align-items-center"
            @click="save(item)"
        >
          <span>{{ item.title }}</span>
          <small class="text-muted">#{{ item.id }}</small>
        </b-list-group-item>
      </b-list-group>
      <div v-else-if="searched" class="text-muted">Ничего не найдено</div>

      <div v-if="song && (song.track || song.artist)" class="mt-1 text-right">
        <b-button variant="outline-danger" size="sm" @click="unlink">Отвязать</b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import {
  BModal, BOverlay, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BButton, BListGroup, BListGroupItem,
} from 'bootstrap-vue'
import { computed, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import chartsApi from './chartsApi'

export default {
  components: {
    BModal, BOverlay, BFormGroup, BInputGroup, BInputGroupAppend, BFormInput, BButton, BListGroup, BListGroupItem,
  },
  model: {
    prop: 'visible',
    event: 'change',
  },
  props: {
    visible: { type: Boolean, default: false },
    song: { type: Object, default: null },
  },
  setup(props, { emit }) {
    const toast = useToast()
    const query = ref('')
    const results = ref([])
    const searched = ref(false)
    const isSearching = ref(false)
    const isSaving = ref(false)

    // Альбомы привязываются только к артисту — у нас нет таблицы альбомов
    const isAlbum = computed(() => props.song && props.song.kind === 'albums')

    const reset = () => {
      query.value = props.song ? (isAlbum.value ? props.song.artist_name : props.song.title) : ''
      results.value = []
      searched.value = false
    }

    const search = async () => {
      if (!query.value) return
      isSearching.value = true
      try {
        const res = isAlbum.value
          ? await chartsApi.searchArtists(query.value)
          : await chartsApi.searchTracks(query.value)
        results.value = res.data.data
        searched.value = true
      } catch (e) {
        toast({
          component: ToastificationContent,
          props: { title: 'Не удалось выполнить поиск', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      } finally {
        isSearching.value = false
      }
    }

    const submit = async payload => {
      isSaving.value = true
      try {
        const res = await chartsApi.linkSong(props.song.id, payload)
        emit('linked', res.data.data)
        emit('change', false)
      } catch (e) {
        toast({
          component: ToastificationContent,
          props: { title: 'Не удалось сохранить привязку', icon: 'AlertTriangleIcon', variant: 'danger' },
        })
      } finally {
        isSaving.value = false
      }
    }

    const save = item => submit(isAlbum.value ? { artist_id: item.id } : { track_id: item.id })
    const unlink = () => submit({ track_id: null, artist_id: null })

    return {
      query, results, searched, isSearching, isSaving, isAlbum, reset, search, save, unlink,
    }
  },
}
</script>
